import { TrackingClient } from '@sparefoot/tracking-client';
import { lifecycle, compose } from 'recompose';

function withPageViewTracking(pageType) {
	return compose(
		lifecycle({
			componentDidMount() {
				if (typeof window !== 'undefined' && TrackingClient) {
					const metaTitle = document.title || pageType;
					TrackingClient.trackPageView({
						page_name: metaTitle,
						page_type: pageType,
					});
				}
			},
		}),
	);
}

export default withPageViewTracking;
